import(/* webpackMode: "eager" */ "/Users/altahan/Desktop/trq/trq_age/app/[locale]/services/page.tsx");
